import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { apiError } from "@/lib/api";
import { homePath } from "@/lib/nav";
import { TrendingUp } from "lucide-react";

const BG = "https://images.unsplash.com/photo-1574023278969-abb7ab49945c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function Login() {
  const { login } = useApp();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const u = await login(email, password);
      navigate(homePath(u));
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5">
          <div>
            <div className="font-heading text-3xl font-extrabold tracking-tight">Incheon Kia <span style={{ color: "#BB162B" }}>MIS</span></div>
            <p className="text-sm text-emerald-600 font-medium mt-1 inline-flex items-center gap-1.5" data-testid="login-tagline"><TrendingUp size={15} className="shrink-0" /> Confidential and access for authorized personnel only.</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" data-testid="login-email-input" value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" data-testid="login-password-input" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
          <Button type="submit" className="w-full" disabled={loading} data-testid="login-submit-btn">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </div>
      <div className="hidden lg:block relative">
        <img src={BG} alt="Dealership" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-black/20" />
      </div>
    </div>
  );
}
